import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  SitelinkInitModel,
  SitelinkInitVariables,
  SitelinkModel,
  SitelinkVariables,
} from '../../../../../models/email-template/sitelink.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-sitelink',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './sitelink.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sitelink.component.scss'
})
export class SitelinkComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: SitelinkModel = new SitelinkInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new SitelinkInitVariables()
    }
  }

  //@ placeholders
  textPlaceholder: string = 'Enter sitelink text';
  firstDescriptionLinePlaceholder: string = 'Enter first description line';
  secondDescriptionLinePlaceholder: string = 'Enter second description line';
  sitelinkLinkPlaceholder: string = 'Enter sitelink URL:';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof SitelinkVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof SitelinkVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
